import { useAuth } from "../../contexts/auth-context";
import { isMyLove } from "../../utils/auth";
import { BrasilEffect } from "./themes/brasil";
import { CopaEffect } from "./themes/copa-theme";
import { HeartEffect } from "./themes/heart";
import { PacocaEffect } from "./themes/pacoca";
import { TextEffect } from "./themes/text-theme";

export function NavbarThemes(){
    const { user } = useAuth();
    const today = new Date();
    const day = today.getDate();
    const month = today.getMonth() + 1;
    const createdAt = new Date(String(user?.created_at));
    
    const isPathyDay = (day === 13 && month === 8) || (day === 15 && month === 7) || (day === 15 && month === 12);

    if (isPathyDay) return <TextEffect text="🥳 🎉" />; //festa
    if(isMyLove(user)) return <HeartEffect/>; // heart
    if(createdAt.getMonth() + 1 == month && createdAt.getDate() == day) return <PacocaEffect/>; // aniversario de conta
    
    // janeiro
    if((day == 25 && month == 12) || (day == 24 && month == 12)) return <TextEffect text="🎅🎄" />; //natal
    if((day == 1 && month == 1) || day == 31 && month == 12) return <TextEffect text="🍾🥂" />; // ano novo

    // fevereiro
    if(day == 11 && month == 2) return <TextEffect text="👩‍🔬🥼🔭🦠🧫🔬" />; // mulher na ciencia
    if(day == 14 && month == 2) return <TextEffect text="👩‍❤️‍👩💖💕" />; // dia dos namorados
    
    // março
    if(day == 3 && month == 3) return <TextEffect text="🐾🐈🐶🐍🦎🐅🐼" />; // dia dos namorados
    if(day == 8 && month == 3) return <TextEffect text="🧔👩👩‍🦰💆‍♀️🧘‍♀️💃" />; // dia da mulher
    if(day == 14 && month == 3) return <TextEffect text="➕⏳➖🧮📐➗" />; // dia da matematica
    if(day == 20 && month == 3) return <TextEffect text="😊🍺🤣😃🙂🤗" />; // dia da felicidade
    if(day == 21 && month == 3) return <TextEffect text="✊🖤🤍" />; // dia Internacional contra a Discriminação Racial
    if(day == 22 && month == 3) return <TextEffect text="💧🚿♒⛲🫗" />; // dia da agua
    
    // abril
    if(day == 2 && month == 4) return <TextEffect text="🧩" />; // dia do Autismo
    if(day == 7 && month == 4) return <TextEffect text="👨‍⚕️👩‍⚕️" />; // dia da Saúde
    if(day == 21 && month == 4) return <TextEffect text="💡" />; // dia da Criatividade e Inovação
    if(day == 22 && month == 4) return <TextEffect text="🌍🌎🌏" />; // dia da terra

    // maio
    if(day == 15 && month == 5) return <TextEffect text="👨‍👩‍👧‍👦👩‍👦👪👩‍👧‍👦" />; // dia da familia
    if(day == 20 && month == 5) return <TextEffect text="🐝" />; // dia da abelha
    if(day == 22 && month == 5) return <TextEffect text="🌱" />; // dia da biodiversidade
    
    // jogos do brasil
    if(day == 13 && month == 6) return <BrasilEffect />; // dia da familia
    if(day == 19 && month == 6) return <BrasilEffect />; // dia da familia
    if(day == 24 && month == 6) return <BrasilEffect />; // dia da familia

    // copa do mundo
    const copaInicio = new Date(2026, 5, 11); // 11/06/2026 (mês começa em 0)
    const copaFim = new Date(2026, 6, 19);    // 19/07/2026
    if(today >= copaInicio && today <= copaFim) return <CopaEffect />;
    
    // junho
    if(day == 1 && month == 6) return <TextEffect text="👨‍👩‍👧👩‍🍼🧑‍🍼" />; // dia dos pais
    if(day == 14 && month == 6) return <TextEffect text="🩸" />; // dia do doador de sangue
    
    // julho
    if(day == 20 && month == 7) return <TextEffect text="🤝🫂👬" />; // dia da amizade
    
    // setembro
    if(day == 1 && month == 9)  return <TextEffect text="🎗️💛" />; // setembro amarelo
    if(day == 5 && month == 9) return <TextEffect text="🤲" />; // dia da caridade
    if(day == 8 && month == 9) return <TextEffect text="📖" />; // dia da alfabetização
    if(day == 21 && month == 9) return <TextEffect text="🕊️🏳️" />; // dia da paz
    
    // outubro
    if(day == 1 && month == 10)  return <TextEffect text="🩷🌹" />; // outubro rosa
    if(day == 5 && month == 10) return <TextEffect text="🧑‍🏫🏫📖🍎" />; // dia da paz
    if(day == 21 && month == 10) return <TextEffect text="🕊️🏳️" />; // dia da paz
    if(day == 31 && month == 10)  return <TextEffect text="🧹🧙🪄🎃" />; // halloween

    // novembro
    if(day == 1 && month == 11) return <TextEffect text="💙" />; //novembro azul
    if(day == 10 && month == 11) return <TextEffect text="🔬🕊️🔭" />; //Ciência para a Paz e o Desenvolvimento
    if(day == 25 && month == 11) return <TextEffect text="🚫🤬👩" />; //Eliminação da Violência contra a Mulher
    
    // dezembro
    if(day == 3 && month == 12) return <TextEffect text="♿👩‍🦯🦮🩼🦻" />; // dia das pessoas com deficiência
    if(day == 5 && month == 12) return <TextEffect text="🤝" />; // dia do voluntariado
    if(day == 10 && month == 12) return <TextEffect text="📜" />; // dia dos direitos humanos
    if(day == 18 && month == 12) return <TextEffect text="🌍" />; // dia dos imigrantes

    return <></>;
}